// Server Configuration
// Manages server selection (demo vs production)

const SERVER_KEY = 'api_server';
const DEMO_SERVER = 'https://api.quonitrix.com/v2';
const PRODUCTION_SERVER = 'https://api.theassetpro.com/v2';

// Get current server selection (default: production)
export const getServer = () => {
  const stored = localStorage.getItem(SERVER_KEY);
  if (stored === 'demo') {
    return DEMO_SERVER;
  }
  // Default to production
  return PRODUCTION_SERVER;
};

// Get server type (demo or production). Default: production.
export const getServerType = () => {
  const stored = localStorage.getItem(SERVER_KEY);
  return stored === 'demo' ? 'demo' : 'production';
};

// Set server selection (caller should confirm before switching)
export const setServer = (type) => {
  if (type === 'demo') {
    localStorage.setItem(SERVER_KEY, 'demo');
  } else {
    localStorage.setItem(SERVER_KEY, 'production');
  }
};

// Get server display name
export const getServerDisplayName = () => {
  const type = getServerType();
  return type === 'production' ? 'Production (theassetpro.com)' : 'Demo (quonitrix.com)';
};

// Get server domain for display
export const getServerDomain = () => {
  const type = getServerType();
  return type === 'production' ? 'theassetpro.com' : 'quonitrix.com';
};

